import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function ScienceLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'navigation-science-link'}
            title={intl.formatMessage({id: 'navigation.link.science.title'})}
            to={Routes.OUR_SCIENCE}
        >
            <span>
                <FormattedMessage id={'navigation.link.science.text'} />
            </span>
        </NavLink>
    );
}
